import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-protected',
  templateUrl: './protected.component.html',
  styleUrls: [
    './protected.component.scss',
    '../../../vendor/styles/pages/authentication.scss'
  ]
})
export class ProtectedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
